<template>
  <v-dialog v-model="dialog" persistent width="1200px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("Coupons.availableCoupons") }}
        <v-spacer />
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          <span>{{ $t("$vuetify.close") }}</span>
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>

      <!-- 表格 -->
      <v-data-table 
        :headers="headers"
        :items="coupons"
        :loading="loading"
        multi-sort
        class="elevation-0 px-6"
        disable-pagination
        hide-default-footer
        height="400px"
      >
        <template v-slot:item.coupon_value="{ item }">
          <span>{{ item.coupon_value }}</span><br /><span>{{ item.coupon_rule_str }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn
            color="primary"
            @click.stop="receive(item.id)"
            class="px-2 me-2 mb-1"
          >
            <span>{{ $t("Coupons.getBtn") }}</span>
          </v-btn>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" depressed @click="receiveAll()">
          {{ $t("Coupons.getAllBtn") }}
        </v-btn>
        <v-btn
          color="primary"
          outlined
          @click="dialog = false"
          class="elevation-1"
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import Coupons from "@/api/coupons";

export default {
  name: "DialogShop",

  props: {
    value: Boolean,
  },
  computed: {
    headers() {
      let headers = [
        {
          text: i18n.t("Coupons.Fields.name"),
          align: "start",
          sortable: true,
          value: "name",
        },
        {
          text: i18n.t("Coupons.Fields.type"),
          align: "start",
          sortable: true,
          value: "type_str",
        },
        {
          text: i18n.t("Coupons.Fields.coupon_value"),
          align: "start",
          sortable: true,
          value: "coupon_value",
        },
        {
          text: i18n.t("Coupons.Fields.valid"),
          align: "start",
          sortable: true,
          value: "valid_str",
        },
        {
          text: i18n.t("Coupons.Fields.rule"),
          align: "start",
          sortable: true,
          value: "rule_content",
          width: 300,
        },
        {
          text: i18n.t("Coupons.Fields.memo"),
          align: "start",
          sortable: true,
          value: "memo",
        },
        {
          text: i18n.t("Coupons.Fields.actions"),
          align: "start",
          sortable: true,
          value: "actions"
        }
      ]
      return headers
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    dialog: false,
    coupons: []
  }),

  methods: {
    getCouponsList() {
      Coupons.couponsList().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.coupons = response.data.coupons
          }
        }.bind(this)
      )
    },
    // 领取单个优惠券
    receive(couponId) {
      Coupons.receive({coupon_id: couponId}).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("Coupons.success"));
            this.getCouponsList()
          }
        }.bind(this)
      )
    },
    receiveAll(){
      Coupons.receiveAll().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("Coupons.success"));
            this.getCouponsList()
          }
        }.bind(this)
      )
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
        if (this.value) {
          this.getCouponsList()
        }else {
          this.coupons = []
        }
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>
